import React from 'react'
import { Modal, Button, Spinner } from 'react-bootstrap'
const Warning = ({ setWarning, warning }) => {
  const handleConfirm = () => {
    warning.onConfirm()
    // 也許你還想在這裡隱藏警告
    setWarning({ ...warning, show: false })
  }
  const handleCancel = () => {
    warning.onCancel()
    // 也許你還想在這裡隱藏警告
    setWarning({
      ...warning,
      show: false,
      msg: '',
      onConfirm: () => {},
      onCancel: () => {},
      isLoading: false,
    })
  }

  // 在警告組件的 JSX 中
  //   <button onClick={handleConfirm}>確認</button>

  return (
    <>
      <Modal
        show={warning.show}
        onHide={() => setWarning({ ...warning, show: false })}
        // dialogClassName="formModalWidth"
        className="metabolic-syndrome-form"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">警告</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <i className="fa-solid fa-triangle-exclamation h1 text-danger"></i>
          <h4>{warning.msg}</h4>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-primary"
            onClick={() => {
              handleCancel()
            }}
          >
            取消
          </Button>
          <Button
            onClick={() => {
              handleConfirm()
            }}
          >
            {warning.confirmMsg}
            <Spinner
              as="span"
              animation={warning.isLoading ? 'border' : ''}
              size="sm"
              role="status"
              aria-hidden="true"
            />
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default Warning
